import { useEffect, useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiError, api } from './api'
import { createAdminWelcome } from './AdminWelcome'

export default function AdminLogin() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [handoff, setHandoff] = useState(false)

  useEffect(() => {
    document.title = 'Studio | TIGG'
  }, [])

  async function onSubmit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api('/api/admin/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      })
      setHandoff(true)
      navigate('/admin', { replace: true, state: createAdminWelcome() })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in.')
    } finally {
      setBusy(false)
    }
  }

  if (handoff) {
    return <div className="min-h-svh bg-white" />
  }

  return (
    <div className="grid min-h-svh place-items-center bg-paper px-5">
      <form onSubmit={(event) => void onSubmit(event)} className="w-full max-w-[360px]">
        <p className="text-caps text-[10px] text-rose">The It Girl Guide</p>
        <h1 className="mt-2 font-serif text-[40px] leading-none font-medium">Studio</h1>
        <p className="mt-3 text-sm text-muted">Sign in to write, edit contributors, and read the numbers.</p>
        <label className="mt-8 block">
          <span className="text-caps mb-1.5 block text-[10px] text-muted">Email</span>
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="w-full border border-rule bg-paper px-3 py-2.5 text-[15px] outline-none focus:border-ink"
          />
        </label>
        <label className="mt-4 block">
          <span className="text-caps mb-1.5 block text-[10px] text-muted">Password</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full border border-rule bg-paper px-3 py-2.5 text-[15px] outline-none focus:border-ink"
          />
        </label>
        {error ? <p className="mt-4 text-sm text-rose">{error}</p> : null}
        <button
          type="submit"
          disabled={busy}
          className="text-caps mt-6 h-12 w-full bg-ink text-white hover:bg-rose disabled:opacity-60"
        >
          {busy ? 'Signing in' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
